import "./bootstrap";
import headerInit from "./components/header";
import scrollInit from "./components/scroll.js";

document.addEventListener("DOMContentLoaded", () => {

    headerInit();
    const { navScrollInit } = scrollInit();
    navScrollInit();
});
